import React, { useState } from "react";
import { Breadcrumbs, Grid2 } from "@mui/material";
import styles from "./CreateOrgOptionStyles.module.scss";
import { useLocation, useNavigate } from "react-router-dom";

// Local imports
//import { fullPaths } from "../../../../../Routes/routes";

// icons
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import { ReactComponent as ClientOrgImage } from "../../../../AdminAssets/svg/ClientOrganization.svg";
import { ReactComponent as NewOrgImage } from "../../../../AdminAssets/svg/NewOrganization.svg";
import CreateOrganization from "../../Pages/CreateOrganizationPage/CreateOrganization";

function CreateOrgOption({ setCurrentView, navbar }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [showOrg, setShowOrg] = useState(
    location.state?.clientOrganizations || null
  );

  const handleShowOrg = () => {
    setShowOrg(false);
    //navigate(fullPaths.organization.createOrg);
  }; // clientOrganization = false
  const handleShowClientOrg = () => {
    setShowOrg(true);
    //navigate(fullPaths.organization.createOrg);
  }; // clientOrganization = true

  const handleBackClick = () => {
    navigate("/account/organizations-overview");
  };

  const handleCancel = () => {
    handleBackClick();
    setCurrentView("overview");
  };

  const handleBackToOptions = () => {
    setShowOrg(null);
  };

  return (
    <>
      <Grid2>
        {showOrg === null && (
          <>
            <Grid2 className={styles.mainContainer}>
              {navbar}
              <Grid2 className={styles.breadcrumbs}>
                <Breadcrumbs
                  aria-label="breadcrumb"
                  separator={<div className={styles.separatorColor}>/</div>}
                >
                  <Grid2 className={styles.options} onClick={handleBackClick}>
                    <CorporateFareIcon />
                    <Grid2 style={{ marginLeft: "5px" }}>Home</Grid2>
                  </Grid2>
                  <Grid2 className={styles.activeOption}>
                    Organization Type
                  </Grid2>
                </Breadcrumbs>
              </Grid2>
              <Grid2>
                <Grid2 className={styles.labelContainer}>
                  <Grid2 className={styles.createlabel}>
                    Select Organization Type
                  </Grid2>
                  <Grid2 className={styles.subLabel}>
                    Begin creating your organization in two simple steps.
                  </Grid2>
                </Grid2>
                <Grid2>
                  <Grid2 className={styles.container}>
                    <Grid2
                      onClick={handleShowOrg}
                      className={styles.createOrgContainer}
                    >
                      <NewOrgImage className={styles.img} />
                      <Grid2 className={styles.title}>
                        Create New Organization
                      </Grid2>
                      <Grid2 className={styles.subTitle}>
                        Create and Configure a New Organization
                      </Grid2>
                    </Grid2>

                    <Grid2
                      onClick={handleShowClientOrg}
                      className={styles.createOrgContainer}
                    >
                      <ClientOrgImage className={styles.img} />
                      <Grid2 className={styles.title}>
                        Create Client Organization
                      </Grid2>
                      <Grid2 className={styles.subTitle}>
                        Setup New Client Organization
                      </Grid2>
                    </Grid2>
                  </Grid2>
                </Grid2>
              </Grid2>
            </Grid2>
          </>
        )}

        {showOrg !== null && (
          <CreateOrganization
            clientOrganization={showOrg}
            onCancel={handleCancel}
            onBackToOptions={handleBackToOptions}
          />
        )}
      </Grid2>
    </>
  );
}

export default CreateOrgOption;
